import {Input, Label} from "reactstrap";
import React from "react";

const LogicalInput = ({ name, onChange }: any) => {
    return (
        <div className="form-check form-switch form-switch-custom form-switch-primary mb-3 mt-4">
            <Input
                className="form-check-input"
                type="checkbox"
                role="switch"
                id="is_active"
                value={1}
                onChange={onChange}
            />
            <Label className="form-check-label" htmlFor="is_active">{name}</Label>
        </div>
    );
};
export default LogicalInput;
